import type { Location } from "react-router-dom"

export type LoginLocationState = { location: Location } | null | undefined

export enum PATHS {
  DASHBOARD = "/",
  AUTH = "/auth",
  CLIENTS = "/clients",
  CUSTOMERS = "/customers",
  PROPERTIES = "/properties",
  PROPERTIES_OLD = "/property-old",
  PROPERTY_OFFERS = "/property-offers",
  INTER_BU = "/inter-bu",
  SHARING = "/sharing",
  RESOURCES = "/resources",
  DIGITAL_TOOLS = "/digital-tools",
  USERS = "/resources/users",
  COLLABORATORS = "/resources/collaborators",
  HELP = "/help",
  NETWORK = "/network",
  ADMIN = "/admin",
  PARAMETERS = "/parameters",
  TADMIN = "/tadmin",
}

export enum CLIENT_PATHS {
  GENERAL = "",
  INHERITANCE = "/inheritance",
  LOGS = "/logs",
}

export enum INTER_BU_PATHS {
  SHARED = "/shared",
  RECEIVED = "/received",
  SENT = "/sent",
  // Administrators' single view, both sides (ADR 0009, D2 revised on 2026-10-16).
  ALL = "/all",
}

export enum SHARING_PATHS {
  INTER_BU = "/interbu",
  PEOPLE = "/people",
  PROJECT = "/project",
}

// Query parameter of the InterBU page that opens the creation (ADR 0013, D3).
export const INTER_BU_CREATE_PARAM = "create"

export enum USER_PATHS {
  GENERAL = "",
}

export enum ADMIN_PATHS {
  COMPANIES = "/companies",
  COMPANY = "/company",
  AGENCIES = "/agencies",
  AGENCY = "/agency",
  CLUSTERS = "/clusters",
  COLLABORATORS = "/collaborators",
  REF_LABELS = "/ref_labels",
  PROPERTIES = "/properties",
  PROJECTS = "/projects",
  PROJECTS_OFFER = "/projects_offer",
  PROJECTS_REQUEST = "/projects_request",
  PEOPLE = "/people",
  SEGMENTS = "/segments",
  SYNCHRO = "/synchro",
  USERS = "/users",
  DASHBOARD = "/dashboard",
}

export enum TADMIN_PATHS {
  SUBSCRIPTIONS = "/subscriptions",
  CIRCLES = "/circles",
  HOBBIES = "/hobbies",
  EVENTS = "/events",
}

export enum RESOURCES_PATHS {
  DOCUMENTS = "/documents",
  MAIL_SIGN = "/mail-sign",
  HELP = "/help",
}

export enum NETWORK_PATHS {
  CLUSTERS = "/clusters",
  COLLABORATORS = "/collaborators",
  MY_COLLABORATORS = "/my_collaborators",
  DIRECTORY = "/directory",
}

export enum PROJECT_PATHS {
  GENERAL = "",
  OFFER = "/offer",
  REQUEST = "/request",
  ADVERTISER = "/advertiser",
  COMMENTS = "/comments",
}

export enum PROPERTY_PATHS {
  GENERAL = "",
  BROADCASTING = "/broadcasting",
  LOGS = "/logs",
}

export enum COMPANY_PATHS {
  GENERAL = "",
  ARCHIVES = "/archives",
  AGENCIES = "/agencies",
  CLUSTERS = "/clusters",
  COLLABORATORS = "/collaborators",
  SETTINGS = "/settings",
}

export enum COLLABORATOR_PATHS {
  GENERAL = "",
  MIGRATE_PEOPLE = "/migrate_people",
  MIGRATE_INTERBU_FROM = "/migrate_interbu_from",
  MIGRATE_INTERBU_TO = "/migrate_interbu_to",
  ARCHIVES = "/archives",
  SETTINGS = "/settings",
  COMPANIES = "/companies",
  AGENCIES = "/agencies",
  CLUSTERS = "/clusters",
  PEOPLE = "/people",
  PROJECTS = "/projects",
  PROJECT_OFFERS = "/project_offers",
  PROJECT_SEARCH = "/project_search",
}

export enum CLUSTER_PATHS {
  GENERAL = "",
  ARCHIVES = "/archives",
  COMPANIES = "/companies",
  AGENCIES = "/agencies",
  COLLABORATORS = "/collaborators",
  PROJECTS = "/projects",
  PROJECT_OFFERS = "/project_offers",
  PROJECT_SEARCH = "/project_search",
  PEOPLES = "/peoples",
  SETTINGS = "/settings",
}

export enum AGENCY_PATHS {
  GENERAL = "",
  ARCHIVES = "/archives",
  COMPANIES = "/companies",
  CLUSTERS = "/clusters",
  COLLABORATORS = "/collaborators",
  SETTINGS = "/settings",
}

export enum PEOPLE_PATHS {
  GENERAL = "",
  COLLABORATORS = "/collaborators",
  PROJECT_OFFERS = "/project_offers",
  PROJECT_SEARCH = "/project_search",
  PROPERTIES = "/properties",
  PROJECTS_PROPERTIES = "/projects_properties",
  COMMENTS = "/comments",
  CLUSTERS = "/clusters",
  SEGMENTS = "/segments",
  SETTINGS = "/settings",
}

export enum PARAMETERS_PATHS {
  DISPLAY = "/display",
  PROFIL = "/profil",
  ACCOUNT = "/account",
  MAIL_SIGN = "/mail_signature",
}

export enum AUTH_PATHS {
  LOGIN = "/login",
  LOGOUT = "/logout",
  REQUEST_PWD = "/request_pwd",
  RENEW_PWD = "/renew_pwd",
}

// The InterBU page with the creation open (dashboard shortcuts, ADR 0013).
export const NEW_INTER_BU_PATH = `${PATHS.SHARING}${SHARING_PATHS.INTER_BU}${INTER_BU_PATHS.RECEIVED}?${INTER_BU_CREATE_PARAM}=1`
